import React from "react";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import StreamCap from "stream/containers/StreamCap";
import FullStoryCard from "cards/containers/FullStoryCard";

import { DEFAULT_CARD_HEIGHT, SECTION, HEADER_LEVELS } from "config/constants";
import { HeaderContext } from "config/contexts";

export default function TopSectionStream(props) {
  return (
    <HeaderContext.Provider value={HEADER_LEVELS.TOP_STORIES_STREAM}>
      <SectionStreamWrapper {...props} slug={SECTION.TOP.slug}>
        {({ streamParams }) => {
          return (
            <>
              <StreamCap addPaddingForStreamTitle={true} />
              <Stream
                {...streamParams}
                defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
                contentComponent={FullStoryCard}
              />
            </>
          );
        }}
      </SectionStreamWrapper>
    </HeaderContext.Provider>
  );
}
